import { Oval } from "react-loader-spinner";

const PRIMARY_COLOR = "#0065FD";
const PRIMARY_TRACK = "#E5E8F3";
const ON_PRIMARY_COLOR = "#FFFFFF";
const ON_PRIMARY_TRACK = "#FFEEFF";

const SIZES = { button: 16, inline: 18, block: 40 };
const ALIGNMENTS = { center: "justify-center", start: "justify-start", end: "justify-end" };

/**
 * The app-wide loading indicator. Every pending state renders one of these
 * rather than a "Loading..." label or a bespoke animation.
 *
 *   button  white spinner sized to sit inside a solid-colour button
 *   inline  small primary spinner for a row, cell or next to text
 *   block   centred primary spinner for a panel, table body or page
 *
 * `align` positions the spinner within its wrapper, for cells whose real
 * content is left-aligned and would otherwise jump when loading finishes.
 */
const Loader = ({ variant = "inline", size, align = "center", className = "", ariaLabel = "loading" }) => {
  const dimension = String(size ?? SIZES[variant] ?? SIZES.inline);
  const onPrimary = variant === "button";

  const spinner = (
    <Oval
      visible
      height={dimension}
      width={dimension}
      strokeWidth={variant === "block" ? 4 : 8}
      color={onPrimary ? ON_PRIMARY_COLOR : PRIMARY_COLOR}
      secondaryColor={onPrimary ? ON_PRIMARY_TRACK : PRIMARY_TRACK}
      ariaLabel={ariaLabel}
    />
  );

  // Buttons lay out their own children, so the spinner goes in bare.
  if (onPrimary) return spinner;

  // `align` is a prop rather than a caller-supplied class because Tailwind emits
  // justify-center after justify-start, so a passed-in override would lose.
  return (
    <div className={`flex items-center ${ALIGNMENTS[align] ?? ALIGNMENTS.center} ${className}`}>{spinner}</div>
  );
};

export default Loader;
